import { useQuery } from "react-query";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { isQueryReady } from "src/api/axiosClient/utils";
import { z } from "zod";

export const getOneProductReferenceApiKey = "productRefOneKey" as const;

type Options = {
    id?: number | null;
};

export const useGetOneProductReference = (options?: Options) => {
    const { id } = options || {};

    const isEnabled = id != null;
    const query = useQuery({
        queryKey: [getOneProductReferenceApiKey, id],
        enabled: isEnabled,
        queryFn: async () => {
            const url = `/api/product_references/${id}`;
            const response = await sureApiCall.get(url);
            return response;
        },
        select: (request) => {
            const productReference = request.data;
            const data = zodParseWithLog(productReference, ProductReferenceSchema, getOneProductReferenceApiKey);
            return data;
        },
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        productReference: query.data,
        isReady,
        ...query,
    };
};

export type ProductReference = {
    id: number;
    name: string;
};

const ProductReferenceSchema: z.ZodSchema<ProductReference> = z.object({
    id: z.number(),
    name: z.string(),
});
